/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root';
import { Route as ParentImport } from './routes/parent';
import { Route as IndexImport } from './routes/index';
import { Route as CallsIndexImport } from './routes/calls/index';
import { Route as XParentImport } from './routes/x_/parent';
import { Route as TestErrorImport } from './routes/test_.error';
import { Route as TestIdImport } from './routes/test.$id';
import { Route as NrAuthTestIdImport } from './routes/nr-auth-test.$id';
import { Route as MessagesFilterImport } from './routes/messages/$filter';
import { Route as HomeDashboardImport } from './routes/home/dashboard';
import { Route as CallsVoicemailsImport } from './routes/calls/voicemails';
import { Route as CallsCallQueueStatsImport } from './routes/calls/call-queue-stats';
import { Route as CallsCallHistoryImport } from './routes/calls/call-history';
import { Route as PublicSignInImport } from './routes/_public/sign-in';
import { Route as PublicPasswordResetImport } from './routes/_public/password-reset';
import { Route as PublicLoginImport } from './routes/_public/login';
import { Route as XRedirect2Import } from './routes/x_/redirect_.2';
import { Route as XRedirect1Import } from './routes/x_/redirect_.1';
import { Route as XParentChildImport } from './routes/x_/parent.child';
import { Route as MessagesFilterNewImport } from './routes/messages/$filter.new';
import { Route as PublicSignInCallbackImport } from './routes/_public/sign-in_.callback';
import { Route as PublicResetPasswordNonceTokenImport } from './routes/_public/reset-password_/$nonceToken';
import { Route as PublicNrPublicTestIdImport } from './routes/_public/nr-public-test.$id';
import { Route as MessagesFilterGroupIdThreadIdImport } from './routes/messages/$filter.$groupId_.$threadId';
import { Route as PublicTestRedirect2Import } from './routes/_public/test_/redirect_.2';
import { Route as PublicTestRedirect1Import } from './routes/_public/test_/redirect_.1';
import { Route as CallsVoicemailBoxesMailboxIdMessagesMessageIdImport } from './routes/calls/voicemail-boxes.$mailboxId.messages.$messageId';
import { Route as PublicUserInviteNonceTokenLocationLocationIdImport } from './routes/_public/user-invite_/$nonceToken_.location_.$locationId';
import { Route as PublicAcceptInviteNonceTokenLocationLocationIdImport } from './routes/_public/accept-invite_/$nonceToken_.location_.$locationId';

// Create/Update Routes

const ParentRoute = ParentImport.update({
  id: '/parent',
  path: '/parent',
  getParentRoute: () => rootRoute,
} as any);

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any);

const CallsIndexRoute = CallsIndexImport.update({
  id: '/calls/',
  path: '/calls/',
  getParentRoute: () => rootRoute,
} as any);

const XParentRoute = XParentImport.update({
  id: '/x_/parent',
  path: '/x/parent',
  getParentRoute: () => rootRoute,
} as any);

const TestErrorRoute = TestErrorImport.update({
  id: '/test_/error',
  path: '/test/error',
  getParentRoute: () => rootRoute,
} as any);

const TestIdRoute = TestIdImport.update({
  id: '/test/$id',
  path: '/test/$id',
  getParentRoute: () => rootRoute,
} as any);

const NrAuthTestIdRoute = NrAuthTestIdImport.update({
  id: '/nr-auth-test/$id',
  path: '/nr-auth-test/$id',
  getParentRoute: () => rootRoute,
} as any);

const MessagesFilterRoute = MessagesFilterImport.update({
  id: '/messages/$filter',
  path: '/messages/$filter',
  getParentRoute: () => rootRoute,
} as any);

const HomeDashboardRoute = HomeDashboardImport.update({
  id: '/home/dashboard',
  path: '/home/dashboard',
  getParentRoute: () => rootRoute,
} as any);

const CallsVoicemailsRoute = CallsVoicemailsImport.update({
  id: '/calls/voicemails',
  path: '/calls/voicemails',
  getParentRoute: () => rootRoute,
} as any);

const CallsCallQueueStatsRoute = CallsCallQueueStatsImport.update({
  id: '/calls/call-queue-stats',
  path: '/calls/call-queue-stats',
  getParentRoute: () => rootRoute,
} as any);

const CallsCallHistoryRoute = CallsCallHistoryImport.update({
  id: '/calls/call-history',
  path: '/calls/call-history',
  getParentRoute: () => rootRoute,
} as any);

const PublicSignInRoute = PublicSignInImport.update({
  id: '/_public/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRoute,
} as any);

const PublicPasswordResetRoute = PublicPasswordResetImport.update({
  id: '/_public/password-reset',
  path: '/password-reset',
  getParentRoute: () => rootRoute,
} as any);

const PublicLoginRoute = PublicLoginImport.update({
  id: '/_public/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any);

const XRedirect2Route = XRedirect2Import.update({
  id: '/x_/redirect_/2',
  path: '/x/redirect/2',
  getParentRoute: () => rootRoute,
} as any);

const XRedirect1Route = XRedirect1Import.update({
  id: '/x_/redirect_/1',
  path: '/x/redirect/1',
  getParentRoute: () => rootRoute,
} as any);

const XParentChildRoute = XParentChildImport.update({
  id: '/child',
  path: '/child',
  getParentRoute: () => XParentRoute,
} as any);

const MessagesFilterNewRoute = MessagesFilterNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => MessagesFilterRoute,
} as any);

const PublicSignInCallbackRoute = PublicSignInCallbackImport.update({
  id: '/_public/sign-in_/callback',
  path: '/sign-in/callback',
  getParentRoute: () => rootRoute,
} as any);

const PublicResetPasswordNonceTokenRoute = PublicResetPasswordNonceTokenImport.update({
  id: '/_public/reset-password_/$nonceToken',
  path: '/reset-password/$nonceToken',
  getParentRoute: () => rootRoute,
} as any);

const PublicNrPublicTestIdRoute = PublicNrPublicTestIdImport.update({
  id: '/_public/nr-public-test/$id',
  path: '/nr-public-test/$id',
  getParentRoute: () => rootRoute,
} as any);

const MessagesFilterGroupIdThreadIdRoute = MessagesFilterGroupIdThreadIdImport.update({
  id: '/$groupId_/$threadId',
  path: '/$groupId/$threadId',
  getParentRoute: () => MessagesFilterRoute,
} as any);

const PublicTestRedirect2Route = PublicTestRedirect2Import.update({
  id: '/_public/test_/redirect_/2',
  path: '/test/redirect/2',
  getParentRoute: () => rootRoute,
} as any);

const PublicTestRedirect1Route = PublicTestRedirect1Import.update({
  id: '/_public/test_/redirect_/1',
  path: '/test/redirect/1',
  getParentRoute: () => rootRoute,
} as any);

const CallsVoicemailBoxesMailboxIdMessagesMessageIdRoute = CallsVoicemailBoxesMailboxIdMessagesMessageIdImport.update({
  id: '/calls/voicemail-boxes/$mailboxId/messages/$messageId',
  path: '/calls/voicemail-boxes/$mailboxId/messages/$messageId',
  getParentRoute: () => rootRoute,
} as any);

const PublicUserInviteNonceTokenLocationLocationIdRoute = PublicUserInviteNonceTokenLocationLocationIdImport.update({
  id: '/_public/user-invite_/$nonceToken_/location_/$locationId',
  path: '/user-invite/$nonceToken/location/$locationId',
  getParentRoute: () => rootRoute,
} as any);

const PublicAcceptInviteNonceTokenLocationLocationIdRoute = PublicAcceptInviteNonceTokenLocationLocationIdImport.update(
  {
    id: '/_public/accept-invite_/$nonceToken_/location_/$locationId',
    path: '/accept-invite/$nonceToken/location/$locationId',
    getParentRoute: () => rootRoute,
  } as any
);

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexImport;
      parentRoute: typeof rootRoute;
    };
    '/parent': {
      id: '/parent';
      path: '/parent';
      fullPath: '/parent';
      preLoaderRoute: typeof ParentImport;
      parentRoute: typeof rootRoute;
    };
    '/_public/login': {
      id: '/_public/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof PublicLoginImport;
      parentRoute: typeof rootRoute;
    };
    '/_public/password-reset': {
      id: '/_public/password-reset';
      path: '/password-reset';
      fullPath: '/password-reset';
      preLoaderRoute: typeof PublicPasswordResetImport;
      parentRoute: typeof rootRoute;
    };
    '/_public/sign-in': {
      id: '/_public/sign-in';
      path: '/sign-in';
      fullPath: '/sign-in';
      preLoaderRoute: typeof PublicSignInImport;
      parentRoute: typeof rootRoute;
    };
    '/calls/call-history': {
      id: '/calls/call-history';
      path: '/calls/call-history';
      fullPath: '/calls/call-history';
      preLoaderRoute: typeof CallsCallHistoryImport;
      parentRoute: typeof rootRoute;
    };
    '/calls/call-queue-stats': {
      id: '/calls/call-queue-stats';
      path: '/calls/call-queue-stats';
      fullPath: '/calls/call-queue-stats';
      preLoaderRoute: typeof CallsCallQueueStatsImport;
      parentRoute: typeof rootRoute;
    };
    '/calls/voicemails': {
      id: '/calls/voicemails';
      path: '/calls/voicemails';
      fullPath: '/calls/voicemails';
      preLoaderRoute: typeof CallsVoicemailsImport;
      parentRoute: typeof rootRoute;
    };
    '/home/dashboard': {
      id: '/home/dashboard';
      path: '/home/dashboard';
      fullPath: '/home/dashboard';
      preLoaderRoute: typeof HomeDashboardImport;
      parentRoute: typeof rootRoute;
    };
    '/messages/$filter': {
      id: '/messages/$filter';
      path: '/messages/$filter';
      fullPath: '/messages/$filter';
      preLoaderRoute: typeof MessagesFilterImport;
      parentRoute: typeof rootRoute;
    };
    '/nr-auth-test/$id': {
      id: '/nr-auth-test/$id';
      path: '/nr-auth-test/$id';
      fullPath: '/nr-auth-test/$id';
      preLoaderRoute: typeof NrAuthTestIdImport;
      parentRoute: typeof rootRoute;
    };
    '/test/$id': {
      id: '/test/$id';
      path: '/test/$id';
      fullPath: '/test/$id';
      preLoaderRoute: typeof TestIdImport;
      parentRoute: typeof rootRoute;
    };
    '/test_/error': {
      id: '/test_/error';
      path: '/test/error';
      fullPath: '/test/error';
      preLoaderRoute: typeof TestErrorImport;
      parentRoute: typeof rootRoute;
    };
    '/x_/parent': {
      id: '/x_/parent';
      path: '/x/parent';
      fullPath: '/x/parent';
      preLoaderRoute: typeof XParentImport;
      parentRoute: typeof rootRoute;
    };
    '/calls/': {
      id: '/calls/';
      path: '/calls';
      fullPath: '/calls';
      preLoaderRoute: typeof CallsIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/_public/nr-public-test/$id': {
      id: '/_public/nr-public-test/$id';
      path: '/nr-public-test/$id';
      fullPath: '/nr-public-test/$id';
      preLoaderRoute: typeof PublicNrPublicTestIdImport;
      parentRoute: typeof rootRoute;
    };
    '/_public/reset-password_/$nonceToken': {
      id: '/_public/reset-password_/$nonceToken';
      path: '/reset-password/$nonceToken';
      fullPath: '/reset-password/$nonceToken';
      preLoaderRoute: typeof PublicResetPasswordNonceTokenImport;
      parentRoute: typeof rootRoute;
    };
    '/_public/sign-in_/callback': {
      id: '/_public/sign-in_/callback';
      path: '/sign-in/callback';
      fullPath: '/sign-in/callback';
      preLoaderRoute: typeof PublicSignInCallbackImport;
      parentRoute: typeof rootRoute;
    };
    '/messages/$filter/new': {
      id: '/messages/$filter/new';
      path: '/new';
      fullPath: '/messages/$filter/new';
      preLoaderRoute: typeof MessagesFilterNewImport;
      parentRoute: typeof MessagesFilterImport;
    };
    '/x_/parent/child': {
      id: '/x_/parent/child';
      path: '/child';
      fullPath: '/x/parent/child';
      preLoaderRoute: typeof XParentChildImport;
      parentRoute: typeof XParentImport;
    };
    '/x_/redirect_/1': {
      id: '/x_/redirect_/1';
      path: '/x/redirect/1';
      fullPath: '/x/redirect/1';
      preLoaderRoute: typeof XRedirect1Import;
      parentRoute: typeof rootRoute;
    };
    '/x_/redirect_/2': {
      id: '/x_/redirect_/2';
      path: '/x/redirect/2';
      fullPath: '/x/redirect/2';
      preLoaderRoute: typeof XRedirect2Import;
      parentRoute: typeof rootRoute;
    };
    '/_public/test_/redirect_/1': {
      id: '/_public/test_/redirect_/1';
      path: '/test/redirect/1';
      fullPath: '/test/redirect/1';
      preLoaderRoute: typeof PublicTestRedirect1Import;
      parentRoute: typeof rootRoute;
    };
    '/_public/test_/redirect_/2': {
      id: '/_public/test_/redirect_/2';
      path: '/test/redirect/2';
      fullPath: '/test/redirect/2';
      preLoaderRoute: typeof PublicTestRedirect2Import;
      parentRoute: typeof rootRoute;
    };
    '/messages/$filter/$groupId_/$threadId': {
      id: '/messages/$filter/$groupId_/$threadId';
      path: '/$groupId/$threadId';
      fullPath: '/messages/$filter/$groupId/$threadId';
      preLoaderRoute: typeof MessagesFilterGroupIdThreadIdImport;
      parentRoute: typeof MessagesFilterImport;
    };
    '/_public/accept-invite_/$nonceToken_/location_/$locationId': {
      id: '/_public/accept-invite_/$nonceToken_/location_/$locationId';
      path: '/accept-invite/$nonceToken/location/$locationId';
      fullPath: '/accept-invite/$nonceToken/location/$locationId';
      preLoaderRoute: typeof PublicAcceptInviteNonceTokenLocationLocationIdImport;
      parentRoute: typeof rootRoute;
    };
    '/_public/user-invite_/$nonceToken_/location_/$locationId': {
      id: '/_public/user-invite_/$nonceToken_/location_/$locationId';
      path: '/user-invite/$nonceToken/location/$locationId';
      fullPath: '/user-invite/$nonceToken/location/$locationId';
      preLoaderRoute: typeof PublicUserInviteNonceTokenLocationLocationIdImport;
      parentRoute: typeof rootRoute;
    };
    '/calls/voicemail-boxes/$mailboxId/messages/$messageId': {
      id: '/calls/voicemail-boxes/$mailboxId/messages/$messageId';
      path: '/calls/voicemail-boxes/$mailboxId/messages/$messageId';
      fullPath: '/calls/voicemail-boxes/$mailboxId/messages/$messageId';
      preLoaderRoute: typeof CallsVoicemailBoxesMailboxIdMessagesMessageIdImport;
      parentRoute: typeof rootRoute;
    };
  }
}

// Create and export the route tree

interface MessagesFilterRouteChildren {
  MessagesFilterNewRoute: typeof MessagesFilterNewRoute;
  MessagesFilterGroupIdThreadIdRoute: typeof MessagesFilterGroupIdThreadIdRoute;
}

const MessagesFilterRouteChildren: MessagesFilterRouteChildren = {
  MessagesFilterNewRoute: MessagesFilterNewRoute,
  MessagesFilterGroupIdThreadIdRoute: MessagesFilterGroupIdThreadIdRoute,
};

const MessagesFilterRouteWithChildren = MessagesFilterRoute._addFileChildren(MessagesFilterRouteChildren);

interface XParentRouteChildren {
  XParentChildRoute: typeof XParentChildRoute;
}

const XParentRouteChildren: XParentRouteChildren = {
  XParentChildRoute: XParentChildRoute,
};

const XParentRouteWithChildren = XParentRoute._addFileChildren(XParentRouteChildren);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/parent': typeof ParentRoute;
  '/login': typeof PublicLoginRoute;
  '/password-reset': typeof PublicPasswordResetRoute;
  '/sign-in': typeof PublicSignInRoute;
  '/calls/call-history': typeof CallsCallHistoryRoute;
  '/calls/call-queue-stats': typeof CallsCallQueueStatsRoute;
  '/calls/voicemails': typeof CallsVoicemailsRoute;
  '/home/dashboard': typeof HomeDashboardRoute;
  '/messages/$filter': typeof MessagesFilterRouteWithChildren;
  '/nr-auth-test/$id': typeof NrAuthTestIdRoute;
  '/test/$id': typeof TestIdRoute;
  '/test/error': typeof TestErrorRoute;
  '/x/parent': typeof XParentRouteWithChildren;
  '/calls': typeof CallsIndexRoute;
  '/nr-public-test/$id': typeof PublicNrPublicTestIdRoute;
  '/reset-password/$nonceToken': typeof PublicResetPasswordNonceTokenRoute;
  '/sign-in/callback': typeof PublicSignInCallbackRoute;
  '/messages/$filter/new': typeof MessagesFilterNewRoute;
  '/x/parent/child': typeof XParentChildRoute;
  '/x/redirect/1': typeof XRedirect1Route;
  '/x/redirect/2': typeof XRedirect2Route;
  '/test/redirect/1': typeof PublicTestRedirect1Route;
  '/test/redirect/2': typeof PublicTestRedirect2Route;
  '/messages/$filter/$groupId/$threadId': typeof MessagesFilterGroupIdThreadIdRoute;
  '/accept-invite/$nonceToken/location/$locationId': typeof PublicAcceptInviteNonceTokenLocationLocationIdRoute;
  '/user-invite/$nonceToken/location/$locationId': typeof PublicUserInviteNonceTokenLocationLocationIdRoute;
  '/calls/voicemail-boxes/$mailboxId/messages/$messageId': typeof CallsVoicemailBoxesMailboxIdMessagesMessageIdRoute;
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/parent': typeof ParentRoute;
  '/login': typeof PublicLoginRoute;
  '/password-reset': typeof PublicPasswordResetRoute;
  '/sign-in': typeof PublicSignInRoute;
  '/calls/call-history': typeof CallsCallHistoryRoute;
  '/calls/call-queue-stats': typeof CallsCallQueueStatsRoute;
  '/calls/voicemails': typeof CallsVoicemailsRoute;
  '/home/dashboard': typeof HomeDashboardRoute;
  '/messages/$filter': typeof MessagesFilterRouteWithChildren;
  '/nr-auth-test/$id': typeof NrAuthTestIdRoute;
  '/test/$id': typeof TestIdRoute;
  '/test/error': typeof TestErrorRoute;
  '/x/parent': typeof XParentRouteWithChildren;
  '/calls': typeof CallsIndexRoute;
  '/nr-public-test/$id': typeof PublicNrPublicTestIdRoute;
  '/reset-password/$nonceToken': typeof PublicResetPasswordNonceTokenRoute;
  '/sign-in/callback': typeof PublicSignInCallbackRoute;
  '/messages/$filter/new': typeof MessagesFilterNewRoute;
  '/x/parent/child': typeof XParentChildRoute;
  '/x/redirect/1': typeof XRedirect1Route;
  '/x/redirect/2': typeof XRedirect2Route;
  '/test/redirect/1': typeof PublicTestRedirect1Route;
  '/test/redirect/2': typeof PublicTestRedirect2Route;
  '/messages/$filter/$groupId/$threadId': typeof MessagesFilterGroupIdThreadIdRoute;
  '/accept-invite/$nonceToken/location/$locationId': typeof PublicAcceptInviteNonceTokenLocationLocationIdRoute;
  '/user-invite/$nonceToken/location/$locationId': typeof PublicUserInviteNonceTokenLocationLocationIdRoute;
  '/calls/voicemail-boxes/$mailboxId/messages/$messageId': typeof CallsVoicemailBoxesMailboxIdMessagesMessageIdRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  '/': typeof IndexRoute;
  '/parent': typeof ParentRoute;
  '/_public/login': typeof PublicLoginRoute;
  '/_public/password-reset': typeof PublicPasswordResetRoute;
  '/_public/sign-in': typeof PublicSignInRoute;
  '/calls/call-history': typeof CallsCallHistoryRoute;
  '/calls/call-queue-stats': typeof CallsCallQueueStatsRoute;
  '/calls/voicemails': typeof CallsVoicemailsRoute;
  '/home/dashboard': typeof HomeDashboardRoute;
  '/messages/$filter': typeof MessagesFilterRouteWithChildren;
  '/nr-auth-test/$id': typeof NrAuthTestIdRoute;
  '/test/$id': typeof TestIdRoute;
  '/test_/error': typeof TestErrorRoute;
  '/x_/parent': typeof XParentRouteWithChildren;
  '/calls/': typeof CallsIndexRoute;
  '/_public/nr-public-test/$id': typeof PublicNrPublicTestIdRoute;
  '/_public/reset-password_/$nonceToken': typeof PublicResetPasswordNonceTokenRoute;
  '/_public/sign-in_/callback': typeof PublicSignInCallbackRoute;
  '/messages/$filter/new': typeof MessagesFilterNewRoute;
  '/x_/parent/child': typeof XParentChildRoute;
  '/x_/redirect_/1': typeof XRedirect1Route;
  '/x_/redirect_/2': typeof XRedirect2Route;
  '/_public/test_/redirect_/1': typeof PublicTestRedirect1Route;
  '/_public/test_/redirect_/2': typeof PublicTestRedirect2Route;
  '/messages/$filter/$groupId_/$threadId': typeof MessagesFilterGroupIdThreadIdRoute;
  '/_public/accept-invite_/$nonceToken_/location_/$locationId': typeof PublicAcceptInviteNonceTokenLocationLocationIdRoute;
  '/_public/user-invite_/$nonceToken_/location_/$locationId': typeof PublicUserInviteNonceTokenLocationLocationIdRoute;
  '/calls/voicemail-boxes/$mailboxId/messages/$messageId': typeof CallsVoicemailBoxesMailboxIdMessagesMessageIdRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/parent'
    | '/login'
    | '/password-reset'
    | '/sign-in'
    | '/calls/call-history'
    | '/calls/call-queue-stats'
    | '/calls/voicemails'
    | '/home/dashboard'
    | '/messages/$filter'
    | '/nr-auth-test/$id'
    | '/test/$id'
    | '/test/error'
    | '/x/parent'
    | '/calls'
    | '/nr-public-test/$id'
    | '/reset-password/$nonceToken'
    | '/sign-in/callback'
    | '/messages/$filter/new'
    | '/x/parent/child'
    | '/x/redirect/1'
    | '/x/redirect/2'
    | '/test/redirect/1'
    | '/test/redirect/2'
    | '/messages/$filter/$groupId/$threadId'
    | '/accept-invite/$nonceToken/location/$locationId'
    | '/user-invite/$nonceToken/location/$locationId'
    | '/calls/voicemail-boxes/$mailboxId/messages/$messageId';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/parent'
    | '/login'
    | '/password-reset'
    | '/sign-in'
    | '/calls/call-history'
    | '/calls/call-queue-stats'
    | '/calls/voicemails'
    | '/home/dashboard'
    | '/messages/$filter'
    | '/nr-auth-test/$id'
    | '/test/$id'
    | '/test/error'
    | '/x/parent'
    | '/calls'
    | '/nr-public-test/$id'
    | '/reset-password/$nonceToken'
    | '/sign-in/callback'
    | '/messages/$filter/new'
    | '/x/parent/child'
    | '/x/redirect/1'
    | '/x/redirect/2'
    | '/test/redirect/1'
    | '/test/redirect/2'
    | '/messages/$filter/$groupId/$threadId'
    | '/accept-invite/$nonceToken/location/$locationId'
    | '/user-invite/$nonceToken/location/$locationId'
    | '/calls/voicemail-boxes/$mailboxId/messages/$messageId';
  id:
    | '__root__'
    | '/'
    | '/parent'
    | '/_public/login'
    | '/_public/password-reset'
    | '/_public/sign-in'
    | '/calls/call-history'
    | '/calls/call-queue-stats'
    | '/calls/voicemails'
    | '/home/dashboard'
    | '/messages/$filter'
    | '/nr-auth-test/$id'
    | '/test/$id'
    | '/test_/error'
    | '/x_/parent'
    | '/calls/'
    | '/_public/nr-public-test/$id'
    | '/_public/reset-password_/$nonceToken'
    | '/_public/sign-in_/callback'
    | '/messages/$filter/new'
    | '/x_/parent/child'
    | '/x_/redirect_/1'
    | '/x_/redirect_/2'
    | '/_public/test_/redirect_/1'
    | '/_public/test_/redirect_/2'
    | '/messages/$filter/$groupId_/$threadId'
    | '/_public/accept-invite_/$nonceToken_/location_/$locationId'
    | '/_public/user-invite_/$nonceToken_/location_/$locationId'
    | '/calls/voicemail-boxes/$mailboxId/messages/$messageId';
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  ParentRoute: typeof ParentRoute;
  PublicLoginRoute: typeof PublicLoginRoute;
  PublicPasswordResetRoute: typeof PublicPasswordResetRoute;
  PublicSignInRoute: typeof PublicSignInRoute;
  CallsCallHistoryRoute: typeof CallsCallHistoryRoute;
  CallsCallQueueStatsRoute: typeof CallsCallQueueStatsRoute;
  CallsVoicemailsRoute: typeof CallsVoicemailsRoute;
  HomeDashboardRoute: typeof HomeDashboardRoute;
  MessagesFilterRoute: typeof MessagesFilterRouteWithChildren;
  NrAuthTestIdRoute: typeof NrAuthTestIdRoute;
  TestIdRoute: typeof TestIdRoute;
  TestErrorRoute: typeof TestErrorRoute;
  XParentRoute: typeof XParentRouteWithChildren;
  CallsIndexRoute: typeof CallsIndexRoute;
  PublicNrPublicTestIdRoute: typeof PublicNrPublicTestIdRoute;
  PublicResetPasswordNonceTokenRoute: typeof PublicResetPasswordNonceTokenRoute;
  PublicSignInCallbackRoute: typeof PublicSignInCallbackRoute;
  XRedirect1Route: typeof XRedirect1Route;
  XRedirect2Route: typeof XRedirect2Route;
  PublicTestRedirect1Route: typeof PublicTestRedirect1Route;
  PublicTestRedirect2Route: typeof PublicTestRedirect2Route;
  PublicAcceptInviteNonceTokenLocationLocationIdRoute: typeof PublicAcceptInviteNonceTokenLocationLocationIdRoute;
  PublicUserInviteNonceTokenLocationLocationIdRoute: typeof PublicUserInviteNonceTokenLocationLocationIdRoute;
  CallsVoicemailBoxesMailboxIdMessagesMessageIdRoute: typeof CallsVoicemailBoxesMailboxIdMessagesMessageIdRoute;
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ParentRoute: ParentRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicPasswordResetRoute: PublicPasswordResetRoute,
  PublicSignInRoute: PublicSignInRoute,
  CallsCallHistoryRoute: CallsCallHistoryRoute,
  CallsCallQueueStatsRoute: CallsCallQueueStatsRoute,
  CallsVoicemailsRoute: CallsVoicemailsRoute,
  HomeDashboardRoute: HomeDashboardRoute,
  MessagesFilterRoute: MessagesFilterRouteWithChildren,
  NrAuthTestIdRoute: NrAuthTestIdRoute,
  TestIdRoute: TestIdRoute,
  TestErrorRoute: TestErrorRoute,
  XParentRoute: XParentRouteWithChildren,
  CallsIndexRoute: CallsIndexRoute,
  PublicNrPublicTestIdRoute: PublicNrPublicTestIdRoute,
  PublicResetPasswordNonceTokenRoute: PublicResetPasswordNonceTokenRoute,
  PublicSignInCallbackRoute: PublicSignInCallbackRoute,
  XRedirect1Route: XRedirect1Route,
  XRedirect2Route: XRedirect2Route,
  PublicTestRedirect1Route: PublicTestRedirect1Route,
  PublicTestRedirect2Route: PublicTestRedirect2Route,
  PublicAcceptInviteNonceTokenLocationLocationIdRoute: PublicAcceptInviteNonceTokenLocationLocationIdRoute,
  PublicUserInviteNonceTokenLocationLocationIdRoute: PublicUserInviteNonceTokenLocationLocationIdRoute,
  CallsVoicemailBoxesMailboxIdMessagesMessageIdRoute: CallsVoicemailBoxesMailboxIdMessagesMessageIdRoute,
};

export const routeTree = rootRoute._addFileChildren(rootRouteChildren)._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/parent",
        "/_public/login",
        "/_public/password-reset",
        "/_public/sign-in",
        "/calls/call-history",
        "/calls/call-queue-stats",
        "/calls/voicemails",
        "/home/dashboard",
        "/messages/$filter",
        "/nr-auth-test/$id",
        "/test/$id",
        "/test_/error",
        "/x_/parent",
        "/calls/",
        "/_public/nr-public-test/$id",
        "/_public/reset-password_/$nonceToken",
        "/_public/sign-in_/callback",
        "/x_/redirect_/1",
        "/x_/redirect_/2",
        "/_public/test_/redirect_/1",
        "/_public/test_/redirect_/2",
        "/_public/accept-invite_/$nonceToken_/location_/$locationId",
        "/_public/user-invite_/$nonceToken_/location_/$locationId",
        "/calls/voicemail-boxes/$mailboxId/messages/$messageId"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/parent": {
      "filePath": "parent.tsx"
    },
    "/_public/login": {
      "filePath": "_public/login.tsx"
    },
    "/_public/password-reset": {
      "filePath": "_public/password-reset.tsx"
    },
    "/_public/sign-in": {
      "filePath": "_public/sign-in.tsx"
    },
    "/calls/call-history": {
      "filePath": "calls/call-history.tsx"
    },
    "/calls/call-queue-stats": {
      "filePath": "calls/call-queue-stats.tsx"
    },
    "/calls/voicemails": {
      "filePath": "calls/voicemails.tsx"
    },
    "/home/dashboard": {
      "filePath": "home/dashboard.tsx"
    },
    "/messages/$filter": {
      "filePath": "messages/$filter.tsx",
      "children": [
        "/messages/$filter/new",
        "/messages/$filter/$groupId_/$threadId"
      ]
    },
    "/nr-auth-test/$id": {
      "filePath": "nr-auth-test.$id.tsx"
    },
    "/test/$id": {
      "filePath": "test.$id.tsx"
    },
    "/test_/error": {
      "filePath": "test_.error.tsx"
    },
    "/x_/parent": {
      "filePath": "x_/parent.tsx",
      "children": [
        "/x_/parent/child"
      ]
    },
    "/calls/": {
      "filePath": "calls/index.tsx"
    },
    "/_public/nr-public-test/$id": {
      "filePath": "_public/nr-public-test.$id.tsx"
    },
    "/_public/reset-password_/$nonceToken": {
      "filePath": "_public/reset-password_/$nonceToken.tsx"
    },
    "/_public/sign-in_/callback": {
      "filePath": "_public/sign-in_.callback.tsx"
    },
    "/messages/$filter/new": {
      "filePath": "messages/$filter.new.tsx",
      "parent": "/messages/$filter"
    },
    "/x_/parent/child": {
      "filePath": "x_/parent.child.tsx",
      "parent": "/x_/parent"
    },
    "/x_/redirect_/1": {
      "filePath": "x_/redirect_.1.tsx"
    },
    "/x_/redirect_/2": {
      "filePath": "x_/redirect_.2.tsx"
    },
    "/_public/test_/redirect_/1": {
      "filePath": "_public/test_/redirect_.1.tsx"
    },
    "/_public/test_/redirect_/2": {
      "filePath": "_public/test_/redirect_.2.tsx"
    },
    "/messages/$filter/$groupId_/$threadId": {
      "filePath": "messages/$filter.$groupId_.$threadId.tsx",
      "parent": "/messages/$filter"
    },
    "/_public/accept-invite_/$nonceToken_/location_/$locationId": {
      "filePath": "_public/accept-invite_/$nonceToken_.location_.$locationId.tsx"
    },
    "/_public/user-invite_/$nonceToken_/location_/$locationId": {
      "filePath": "_public/user-invite_/$nonceToken_.location_.$locationId.tsx"
    },
    "/calls/voicemail-boxes/$mailboxId/messages/$messageId": {
      "filePath": "calls/voicemail-boxes.$mailboxId.messages.$messageId.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
